import { type ThemeOptions } from '@mui/material';

// Adding as a new file with the assumption that we will need to add focus style overrides in ZDS-602
export function createButtonGroupStyles() {
  return {
    MuiButtonGroup: {
      defaultProps: {
        disableRipple: true,
      },
    },
  } as ThemeOptions['components'];
}
